import React from 'react';
export var TabContext = /*#__PURE__*/React.createContext({
  isLastTab: function isLastTab() {
    return false;
  },
  registerTab: function registerTab() {
    return false;
  },
  unregisterTab: function unregisterTab() {},
  changeTab: function changeTab() {}
});
export var useTabContext = function useTabContext() {
  return React.useContext(TabContext);
};